<template>
<div>
    <navi selectedid="tlMediaCenter"></navi>
    <subNavi selectedid="tlVideo" lastrouter="/media/news" nextrouter="/media/interaction"></subNavi>
    
    <div id="Contents">
        <!-- <div id="Logo">
            <h1 title="Arivo Tyre"><img src="../../common/images/common/logo.png" alt="Arivo Tyre" width="229" height="42"></h1>
            <h2 title="HOME"><a href="../index.html" title="HOME"><img src="../../common/images/top/home.png" alt="HOME" width="229" height="219"></a></h2>

            <siteMenu></siteMenu>
        </div> -->
        <logo selectedid="tlMediaCenter"></logo>

        <spNavi selectedid="tlVideo"></spNavi>

        <div id="Main">
            <div class="media-article">
                <h2 title="VIDEO">VIDEO</h2>
                <div class="video-container">
                     <video src="http://59.80.44.91/vjs.zencdn.net/v/oceans.mp4" controls="controls" poster="../../common/images/top/bg_01.jpg" width="100%" height="400px" title="Test">
                        <source src="http://59.80.44.91/vjs.zencdn.net/v/oceans.mp4" type="video/mp4">
                    </video>
                    <span>Test</span>
                </div>
            </div>

            <share></share>
        </div>
    </div>
    <webFooter></webFooter>
</div>
</template>
<script>
import Navi from "components/common/navi";
import SubNavi from "components/media/subnavi";
import Logo from "components/common/logo";
import SpNavi from "components/media/spnavi";
import Share from "components/common/share";
import WebFooter from "components/common/footer";
export default {
  name: "News",
  components: {
    Navi,
    SubNavi,
    Logo,
    SpNavi,
    Share,
    WebFooter
  },
  data() {
    return {
        videos: []
    };
  }
};
</script>
<style>
.video-container{
    width: 100%;
    text-align: center;
}

.video-container span{
    margin-top: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/media/video.vue